import { Token as TokenModel } from './Token';

export const Token = new TokenModel();



// WEBPACK FOOTER //
// ./src/models/index.js